module.exports = __webpack_public_path__ + "img/9788925588711.6241236e.jpg";